export default __webpack_public_path__ + "static/media/gupsuStart_overlay.10141c18.svg";